import { TextField } from '@material-ui/core'
import { useRef } from 'react'
import { Box } from 'reoil'
import useUpload, { UploadResponse } from '../../hooks/api/useUpload'

interface UploadFileProps {
  label?: string
  placeholder?: string
  initialFilename?: string
  onChange?: (value: UploadResponse)=>void
  [key: string]: unknown
}

const UploadFile: React.FC<UploadFileProps> = ({onChange, label='作品附件上传', initialFilename, placeholder='暂无作品，请上传'}) => {
  const {handleChange, response, file} = useUpload(onChange)
  const inputRef = useRef<HTMLInputElement>(null)

  const handleClick = ()=>{
    inputRef.current?.click()
  }

  return(
    <Box className='UploadFile' row center left mb={3}>
      <TextField label={label} helperText='最大上传20MB, 支持.doc .docx .pdf .jpg .jpeg文件' onClick={handleClick} placeholder={placeholder} value={response?.fileName || file?.name ||initialFilename} style={{flex: 2}} required/>
      {/* <Box>作品附件上传</Box> */}

      <input ref={inputRef} style={{display: 'none'}} type="file" onChange={handleChange} name='file' accept='.doc,.docx,.pdf,.jpg,.jpeg' />
    </Box>
  )
}

export default UploadFile
